import styled from "styled-components";
import { Table } from "react-bootstrap";

export const StyledTable = styled(Table)`
  border-spacing: 0px;
  border-collapse: separate;
  font-size: var(--font-size-base);
  @media screen and (max-width: 576px) {
    font-size: var(--font-size-xs);
  }
  tr th {
    background: var(--primary-color);
    border: 1px solid var(--white-color);
    border-bottom: none;
    color: var(--white-color);
    font-weight: 500;
    &:first-child {
      border-radius: 0px 10px 0px 0px;
      border-right: none;
    }
    &:last-child {
      border-radius: 10px 0px 0px 0px;
      border-left: none;
    }
  }
  tr td {
    background: var(--white-color);
    color: var(--blue-color-dark);
    border: 1px solid var(--primary-color);
    @media screen and (max-width: 576px) {
      padding: 3px;
    }
  }
  tbody {
    .tbody-last-tr {
      td:first-child {
        border-radius: 0px 0px 10px 0px;
      }
      td:last-child {
        border-radius: 0px 0px 0px 10px;
      }
    }
  }
`;
